// src/utils/auth.js
import { jwtDecode } from 'jwt-decode';

/**
 * Check whether a JWT token string is present and not expired.
 */
export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const { exp } = jwtDecode(token);
    return exp && Date.now() < exp * 1000;
  } catch {
    return false;
  }
};
